<template>
  <div class="menu-wrapper sidebar">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
                   :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}" :title="generateTitle(item.children[0].meta.title)">
          <div v-if="item.children[0].meta&&item.children[0].meta.icon" :class='"icon_"+item.children[0].meta.icon'></div>
          <!--<img v-if="item.children[0].meta&&item.children[0].meta.icon" src="../../../../common/images/icon100-07.png" style="width: 35px;height: 35px;">-->
          <!--<svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon" class="d"></svg-icon>-->
          <span v-if="item.children[0].meta&&item.children[0].meta.title&&isSlot"  slot="title">{{generateTitle(item.children[0].meta.title)}}</span>
          <span v-if="item.children[0].meta&&item.children[0].meta.title&&!isSlot">{{generateTitle(item.children[0].meta.title)}}</span>
        </el-menu-item>
      </router-link>
    </template>
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    isSlot: {//是否设置slot属性
      type: Boolean,
      default: false
    },

  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    generateTitle
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  .el-menu-item{
    .icon_device{
      background:url(../../../../common/images/shezhi02.png) no-repeat center ;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_broadcast{
      background:url(../../../../common/images/guangbo02.png) no-repeat;
      background-size:35px 35px;
      display: inline-block;
      width: 35px;
      height: 35px;
    }
    .icon_resources{
      background:url(../../../../common/images/ziyuan02.png) no-repeat ;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_schedule{
      background:url(../../../../common/images/richeng02.png) no-repeat ;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_live{
      background:url(../../../../common/images/streaming3.png) no-repeat ;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_meetingRoom{
      background:url(../../../../common/images/meetingRoom.png) no-repeat ;
      display: inline-block;
      background-size:40px 40px;
      width: 40px;
      height: 40px;
    }
  }
  .is-active{
    .icon_device{
      background:url(../../../../common/images/shezhi01_1.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_broadcast{
      background:url(../../../../common/images/guangbo01.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_resources{
       background:url(../../../../common/images/ziyuan01.png) no-repeat center !important;
       display: inline-block;
       background-size:35px 35px;
       width: 35px;
       height: 35px;
     }
    .icon_schedule{
      background:url(../../../../common/images/richeng01.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_live{
      background:url(../../../../common/images/streaming2.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_meetingRoom{
      background:url(../../../../common/images/meetingRoomActive.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 40px;
      height: 40px;
    }
  }
  .sidebar a :hover{
    .icon_device{
      background:url(../../../../common/images/shezhi01_1.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }

    .icon_broadcast{
      background:url(../../../../common/images/guangbo01.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }

    .icon_resources{
      background:url(../../../../common/images/ziyuan01.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_schedule{
      background:url(../../../../common/images/richeng01.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_live{
      background:url(../../../../common/images/streaming2.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 35px;
      height: 35px;
    }
    .icon_meetingRoom{
      background:url(../../../../common/images/meetingRoomActive.png) no-repeat center !important;
      display: inline-block;
      background-size:35px 35px;
      width: 40px;
      height: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue